import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { useCloseFormPopup } from 'APP/main/PopupManager/hooks/useCloseFormPopup';

import {
  ICreateStreamPopupPresenterParams,
  useCreateStreamPopupPresenter,
} from './CreateStreamPopup.presenter';
import styles from './CreateStreamPopup.styles.m.css';
import { StreamForm } from './StreamForm/StreamForm';

type ICreateStreamPopupProps = ICreateStreamPopupPresenterParams;

export const CreateStreamPopup: FC<ICommonPopupsProps<ICreateStreamPopupProps>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useCreateStreamPopupPresenter(props);
    const closeForm = useCloseFormPopup(props, t('common_cancel_action_confirmation'));

    return (
      <Popup
        className={styles.formPopup}
        isOpened
        title={t('new_stream_setting_title')}
        onClose={closeForm.closePopup}
      >
        <StreamForm
          onFormStateChange={closeForm.onFormStateChange}
          onSubmit={presenter.onSubmit}
        />
      </Popup>
    );
  }
);
